module.exports = __webpack_public_path__ + "mainassets/img/chevron-top-bright.107a4520.svg";